import r2wc from '@r2wc/react-to-web-component';
import VinTotalLeadsWebComponent from './VinTotalLeadsWebComponent';
const VinTotalLeadsWrappedWebComponent = r2wc(VinTotalLeadsWebComponent, {
    shadow: 'open',
    props: {
        commonOrgId: 'string',
        partition: 'string',
    },
});
if (!customElements.get('cmd-ctr-vin-total-leads')) {
    customElements.define('cmd-ctr-vin-total-leads', VinTotalLeadsWrappedWebComponent);
}
export { 
// eslint-disable-next-line import/prefer-default-export
VinTotalLeadsWrappedWebComponent, };
